/**
 * A Fiona card with its lifecycle: status pill and follow-up line, the
 * card's content (FionaDecisionCard), and what can be done with it
 * (FionaActions). Used for today's and next-fee-schedule cards alike.
 */

import { Box } from "@mui/material";
import React from "react";

import { AGENT_INFO } from "../../../constants";
import FionaDecisionCard from "../../StoreProductsAnalysis/FionaDecisionCard";

import FionaActions, { FionaStatus, useFionaOptions } from "./FionaActions";

// withStatusPills false when the row around the card already shows them
const FionaCard = ({
  decision,
  store,
  marketplace,
  onCardChanged,
  withStatusPills = true,
}) => {
  const options = useFionaOptions(store, marketplace);
  return (
    // Indented to the row's title (the accordion already indents 28px), with
    // Fiona's picture by the buttons, as on the other agents' cards
    <Box sx={{ position: "relative", p: "6px 24px 26px 30px" }}>
      <Box
        component="img"
        src={AGENT_INFO.fiona.avatar}
        alt=""
        sx={{
          position: "absolute",
          bottom: "-14px",
          right: "-18px",
          width: 96,
          height: 96,
          opacity: 0.7,
          pointerEvents: "none",
        }}
      />
      <FionaStatus
        fionaCard={decision.fiona_card}
        withPills={withStatusPills}
      />
      <FionaDecisionCard fionaData={decision} />
      <FionaActions
        decision={decision}
        store={store}
        marketplace={marketplace}
        options={options}
        onCardChanged={(change) => onCardChanged?.(decision, change)}
      />
    </Box>
  );
};

export default FionaCard;
